import { Link2, Plus, RotateCw, StickyNote } from "lucide-react";
import { formatUpdated } from "../lib/format";
import type { SyncStatus } from "../types";
import { ClearPadDialog } from "./ClearPadDialog";
import { StatusBadge } from "./StatusBadge";
import { Button } from "./ui/Button";

export function TopBar({
  status,
  clients,
  updatedAt,
  onCopyLink,
  onNewPad,
  onClear,
  onReload,
}: {
  status: SyncStatus;
  clients: number;
  updatedAt: number;
  onCopyLink: () => Promise<void>;
  onNewPad: () => void;
  onClear: () => Promise<void>;
  onReload: () => void;
}) {
  return (
    <header className="flex min-h-20 min-w-0 flex-col gap-4 bg-white px-4 py-4 lg:flex-row lg:items-center lg:justify-between lg:px-6">
      <div className="flex min-w-0 flex-wrap items-center gap-3">
        <div className="flex min-w-0 items-center gap-2 text-2xl font-semibold tracking-normal text-neutral-950" aria-label="Slip">
          <span className="grid size-9 place-items-center rounded-md border border-neutral-200 bg-white text-neutral-950 shadow-[0_1px_1px_rgba(0,0,0,0.04)]">
            <StickyNote size={21} strokeWidth={2.2} />
          </span>
          <span>Slip</span>
        </div>
        <StatusBadge status={status} clients={clients} />
        <span className="hidden h-5 w-px bg-neutral-200 sm:block" aria-hidden="true" />
        <span className="text-sm text-neutral-500">{formatUpdated(updatedAt)}</span>
      </div>

      <div className="grid min-w-0 grid-cols-4 gap-2 sm:flex sm:flex-wrap sm:justify-end">
        <Button onClick={() => void onCopyLink()} title="Copy link">
          <Link2 size={18} />
          <span className="hidden sm:inline">Copy link</span>
        </Button>
        <Button onClick={onNewPad} variant="primary" title="New Slip">
          <Plus size={18} />
          <span className="hidden sm:inline">New Slip</span>
        </Button>
        <ClearPadDialog onClear={onClear} />
        <Button onClick={onReload} size="icon" variant="secondary" title="Reconnect">
          <RotateCw size={18} />
        </Button>
      </div>
    </header>
  );
}
